import * as Dati from "src/Dati";
import * as DatiFide from "src/DatiFide";

export const getEstablishmentYears = (value: Date): number => {
    const year = value?.getFullYear();

    if (year && year > 1901) {
        return new Date(Date.now()).getFullYear() - year;
    }
    return 0;
};

export const getIndex = (value: string): number => {
    if (value) {
        if (value.indexOf("R") >= 0) {
            return 1;
        } else if (value.indexOf("G") >= 0) {
            return 2;
        }
        return 3;
    }
    return 0;
};

export const getPrejudicialsIndex = (value: string): number => {
    let index = 0;

    if (value) {
        let properValue = value.trim();

        if (properValue.length == 2) {
            properValue += "V";
        }
        switch (properValue) {
            case "VVV":
            case "VGV":
            case "GVV":
            case "VVG":
                index = 3;
                break;
            case "VRV":
            case "VGG":
            case "VRG":
            case "VVR":
            case "VGR":
            case "GGV":
            case "GRV":
            case "GVG":
            case "GGG":
            case "GRG":
            case "GVR":
            case "GGR":
                index = 2;
                break;
            case "VRR":
            case "GRR":
            case "RVV":
            case "RGV":
            case "RRV":
            case "RVG":
            case "RGG":
            case "RRG":
            case "RVR":
            case "RGR":
            case "RRR":
                index = 1;
                break;
        }
    }

    return index;
};

export const getFinancialSituation = (economicData: Dati.CDatiEconomici): number => {
    let financialSituation: number =
        (economicData.DebitiOltreBTVersoBanche + economicData.DebitiCorrentiVersoBanche - economicData.AttivitaFinanziarie - economicData.Liquidita) / economicData.MargineOperativoLordo;

    if (economicData.DebitiOltreBTVersoBanche + economicData.DebitiCorrentiVersoBanche - economicData.AttivitaFinanziarie - economicData.Liquidita < 0 && economicData.MargineOperativoLordo >= 0) {
        financialSituation = 0;
    } else if (economicData.MargineOperativoLordo < 0) {
        financialSituation = 10;
    }
    return financialSituation;
};

const getValue = (limitA: number, limitB: number, val: number, direction: string, cancellationVal?: number, defaultVal?: number): number => {
    if (cancellationVal != undefined && defaultVal != undefined && cancellationVal == val) {
        return defaultVal;
    }
    if (direction == ">") {
        if (val >= limitA) return 5;
        else if (val >= limitB && val < limitA) return 3;
    } else {
        if (val <= limitA) return 5;
        else if (val > limitA && val <= limitB) return 3;
    }
    return 1;
};

export const getTotalIndex = (data: DatiFide.CDatiFideValutazione, economicData: Dati.CDatiEconomici): number => {
    const protestsIndex = getIndex(economicData.Protesti || "");
    const prejudicialsIndex = getPrejudicialsIndex(economicData.Pregiudizievoli || "");
    const insolvencyProceedingsIndex = getIndex(economicData.ProcedureConcorsuali || "");
    const establishmentYears = getEstablishmentYears(economicData.DataCostituzione);
    let totalIndex: number = 0;

    //Limit of Exposure VS Net Capital
    totalIndex += getValue(1, 5, data.ImportoAffidamento / data.PatrimonioNetto, "<");

    //Profitability
    totalIndex += getValue(0.1, 0.03, data.MargineOperativo / data.PatrimonioNetto, ">");

    //Financial Situation
    totalIndex += getValue(1, 0.85, data.AttivoCircolante / data.DebitiBreve, ">");

    //Liabilities VS Net Capital
    totalIndex += getValue(2.5, 7, data.TotalePassivo / data.PatrimonioNetto, "<");

    //Turnover vs Curret Assets
    totalIndex += getValue(1.5, 0.5, data.ValoreProduzione / data.AttivoCircolante, ">");

    //Production Trend
    totalIndex += getValue(1.1, 0.75, data.ValoreProduzione / data.ValoreProduzionePrecedente, ">");

    //Prejudicials
    totalIndex += getValue(3, 2, prejudicialsIndex, ">");

    //Years of Establishment
    totalIndex += getValue(5, 3, establishmentYears, ">");

    //Score (indice sintetico Ribes)
    totalIndex += getValue(3, 6, economicData.Punteggio, "<");

    //Asset Turnover
    totalIndex += getValue(8, 4, economicData.IndiceSettorialeAssetTurnover, ">", 0, 4);

    //Interest Coverage (Copertura Interessi)
    totalIndex += getValue(8, 4, economicData.IndiceSettorialeCoperturaInteressi, ">", 0, 4);

    //Current Ratio
    totalIndex += getValue(8, 4, economicData.IndiceSettorialeCurrentRatio, ">", 0, 4);

    //Average Duration of Liabilities (Durata Media dei Debiti)
    totalIndex += getValue(8, 4, economicData.IndiceSettorialeDurataMediaDeiDebiti, ">", 0, 4);

    //Self-Coverage of Fixed Assets (Autocopertura Immobilizzazioni)
    totalIndex += getValue(8, 4, economicData.IndiceSettorialeIndiceDiAutocoperturaDelleImmobilizzazioni, ">", 0, 4);

    //Leverage
    totalIndex += getValue(8, 4, economicData.IndiceSettorialeLeverage, ">", 0, 4);

    //Financials Costs Turnover (Oneri fin./Val. Produzione)
    totalIndex += getValue(8, 4, economicData.IndiceSettorialeOneriFinanziariValoreProduzione, ">", 0, 4);

    //Quick Ratio
    totalIndex += getValue(8, 4, economicData.IndiceSettorialeQuickRatio, ">", 0, 4);

    //ROE
    totalIndex += getValue(8, 4, economicData.IndiceSettorialeROE, ">", 0, 4);

    //ROI
    totalIndex += getValue(8, 4, economicData.IndiceSettorialeROI, ">", 0, 4);

    //ROS
    totalIndex += getValue(8, 4, economicData.IndiceSettorialeROS, ">", 0, 4);

    totalIndex += getValue(30, 16, economicData.NumeroDipendenti, ">");

    //SEZIONE BLOCCO
    if (protestsIndex <= 1 || insolvencyProceedingsIndex <= 1 || economicData.Punteggio == 0) totalIndex = 0;

    return totalIndex;
};



// WEBPACK FOOTER //
// ./src/inar2/components/BondsAssessment/helpers.ts